var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.844,
    height: 103.243,
    viewBox: "0 0 156.844 103.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-1,.cls-2{stroke:#707070;stroke-width:2px}.cls-1,.cls-2,.cls-3{fill-rule:evenodd}.cls-2{fill:#a1a0a0}.cls-3{fill:#fff}.cls-4{fill:#0a5369}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Truck",
    transform: "translate(-1148 -502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    transform: "translate(833.231 238.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    d: "M407.112 281.13h23.936c3.907 0 5.864 2.456 7.815 5.408l19.049 27.031c4.886 1.475 8.793 1.475 9.773 8.355v17.694c1.956 0 2.928.492 2.928 1.969v6.878c0 1.477-.978 1.97-2.928 1.97h-14.652c.488-10.318-8.3-19.166-19.049-19.166a19.46 19.46 0 0 0-19.05 19.166h-50.31a19.05 19.05 0 1 0-38.1 0h-5.864a4.915 4.915 0 0 1-4.885-4.916v-31.454h91.343v-32.929z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    d: "M315.769 310.621V269.83a4.912 4.912 0 0 1 4.887-4.917h76.2a4.914 4.914 0 0 1 4.886 4.917v40.792h-85.973z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    d: "M433.976 335.2a15.484 15.484 0 1 1-15.142 15.235 15.372 15.372 0 0 1 15.142-15.235z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    d: "M433.976 343.552a7.113 7.113 0 0 1 7.327 6.879 7.534 7.534 0 0 1-7.325 7.37c-3.908 0-6.837-3.44-6.837-7.37a6.694 6.694 0 0 1 6.835-6.879z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    d: "M345.563 335.2c8.305 0 15.631 6.879 15.631 15.235a15.784 15.784 0 0 1-15.631 15.725 15.484 15.484 0 0 1 0-30.96z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    d: "M345.563 343.552a7.112 7.112 0 0 1 7.326 6.879 7.326 7.326 0 1 1-14.651 0 7.113 7.113 0 0 1 7.325-6.879zm67.9-57.012v27.52h37.125l-15.631-24.081c-1.468-1.97-2.931-3.439-5.867-3.439h-15.629z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    transform: "translate(1160.618 519.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M222.181-780.761h11.2v1.328h-4.872V-766h-1.456v-13.437h-4.872z",
    className: "cls-4",
    transform: "translate(-222.181 780.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M232.36-768.444a4.558 4.558 0 0 0 3.427 1.265 4.526 4.526 0 0 0 3.418-1.265 4.892 4.892 0 0 0 1.223-3.544v-8.773h1.456v8.773a6.1 6.1 0 0 1-1.613 4.494 6.043 6.043 0 0 1-4.483 1.624 6.073 6.073 0 0 1-4.492-1.624 6.069 6.069 0 0 1-1.624-4.494v-8.773h1.456v8.773a4.861 4.861 0 0 0 1.232 3.544z",
    className: "cls-4",
    transform: "translate(-213.935 780.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M238.637-780.751h1.454v13.435h6.5v1.309h-7.952z",
    className: "cls-4",
    transform: "translate(-204.065 780.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M247.42-768.444a4.558 4.558 0 0 0 3.427 1.265 4.526 4.526 0 0 0 3.418-1.265 4.892 4.892 0 0 0 1.223-3.544v-8.773h1.456v8.773a6.1 6.1 0 0 1-1.614 4.494 6.042 6.042 0 0 1-4.483 1.624 6.072 6.072 0 0 1-4.492-1.624 6.069 6.069 0 0 1-1.624-4.494v-8.773h1.456v8.773a4.861 4.861 0 0 0 1.233 3.544z",
    className: "cls-4",
    transform: "translate(-197.356 780.761)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep03);
export default __webpack_public_path__ + "static/media/step0_3.b03818daac64742268b504e0b1688464.svg";
export { ForwardRef as ReactComponent };